export const CHUNK_RELOAD_KEY = "rv-chunk-reload";
export const CACHE_BUST_PARAM = "_rv";

// Drops the one-shot cache-bust query after a hard reload so filter params
// and shareable URLs stay clean. Does not touch localStorage, cookies, or
// IndexedDB — those hold auth and drafts.
export function stripCacheBustParam() {
  if (typeof window === "undefined") return;
  try {
    const url = new URL(window.location.href);
    if (!url.searchParams.has(CACHE_BUST_PARAM)) return;
    url.searchParams.delete(CACHE_BUST_PARAM);
    window.history.replaceState(
      window.history.state,
      "",
      `${url.pathname}${url.search}${url.hash}`
    );
  } catch {
    // ignore
  }
}

export async function unregisterLeftoverServiceWorkers() {
  if (typeof navigator === "undefined" || !navigator.serviceWorker?.getRegistrations) {
    return;
  }
  const registrations = await navigator.serviceWorker.getRegistrations();
  await Promise.all(registrations.map((registration) => registration.unregister()));
}

// Service-worker Cache Storage only. HTTP disk cache is busted by the
// `_rv` query on the document request — we never clear site data.
export async function clearStaleAssetCaches() {
  await unregisterLeftoverServiceWorkers();
  if (typeof caches !== "undefined" && caches.keys) {
    const keys = await caches.keys();
    await Promise.all(keys.map((key) => caches.delete(key)));
  }
}

export async function hardReloadApp() {
  try {
    await clearStaleAssetCaches();
  } catch {
    // still navigate — cache APIs are best-effort
  }
  if (typeof window === "undefined") return;
  const url = new URL(window.location.href);
  url.searchParams.set(CACHE_BUST_PARAM, String(Date.now()));
  window.location.replace(url.toString());
}
